import React, { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Lang, Team, TFile } from '@brg/api';
import styled from 'styled-components';
import ProjectCardLayoutNew from '../projectCard/projectCardLayoutNew';

export interface AdBlockCardProps {
  team?: Team;
  itemType?: string;
  currentTab?: string;
}

const PartnerBadge = styled.div`
  background: rgba(49, 49, 49, 0.4);
  border-radius: 3px;
  padding: 6px 18px;
  font-size: 12px;
  line-height: 1.2;
  color: #FFFFFF;
  backdrop-filter: blur(4px);
`;

export const AdBlockCard: FC<AdBlockCardProps> = ({ team, itemType, currentTab }) => {
  const { i18n, t } = useTranslation();

  const adBlockCard = useMemo(() => {

    const tabs = team?.tabs || [];
    const currentTabData = currentTab ? tabs.find((tab: any) => tab.path === currentTab) : tabs.find((tab: any) => tab.isMain) || tabs[0];
 
    if (!currentTabData?.isShowAdBlock || !currentTab) return null;

    const adBlockText = currentTabData.adBlockText || [];
    const adBlockLink = currentTabData.adBlockLink;
    const adBlockImages = currentTabData.adBlockImages || [];
    
    const adBlockTitle = Lang(adBlockText, i18n.language) || '';
    
    let titleImages: TFile[] | undefined = undefined;

    if (adBlockImages?.length) {
      //@ts-ignore
      const originalImage = adBlockImages.find((img: any) => img.size === 'original' || !img.size) || adBlockImages[0];
      titleImages = originalImage ? [originalImage] : undefined;
    }

    return (
      <ProjectCardLayoutNew
        key="ad-block-card"
        identifier={team?.teamId}
        title={adBlockTitle}
        titleImages={titleImages}
        linkTo={adBlockLink || undefined}
        withoutGoToProject={!adBlockLink}
        projectType={'t-shape'}
        lmsCardType={'t-shape'}
        itemType={itemType}
        topBadge={<PartnerBadge>{t('text.partner_material')}</PartnerBadge>}
      />
    );
  }, [team, i18n.language, itemType, currentTab]);

  return adBlockCard;
};

import React, { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Lang, Team, TFile } from '@brg/api';
import styled from 'styled-components';
import ProjectCardLayoutNew from '../projectCard/projectCardLayoutNew';

export interface AdBlockCardProps {
  team?: Team;
  itemType?: string;
  currentTab?: string;
}

const PartnerBadge = styled.div`
  background: rgba(49, 49, 49, 0.4);
  border-radius: 3px;
  padding: 6px 18px;
  font-size: 12px;
  line-height: 1.2;
  color: #FFFFFF;
  backdrop-filter: blur(4px);
`;

export const AdBlockCard: FC<AdBlockCardProps> = ({ team, itemType, currentTab }) => {
  const { i18n, t } = useTranslation();

  const adBlockCard = useMemo(() => {

    const tabs = team?.tabs || [];
    const currentTabData = currentTab ? tabs.find((tab: any) => tab.path === currentTab) : tabs.find((tab: any) => tab.isMain) || tabs[0];
 
    if (!currentTabData?.isShowAdBlock || !currentTab) return null;

    const adBlockText = currentTabData.adBlockText || [];
    const adBlockLink = currentTabData.adBlockLink;
    const adBlockImages = currentTabData.adBlockImages || [];
    
    const adBlockTitle = Lang(adBlockText, i18n.language) || '';
    
    let titleImages: TFile[] | undefined = undefined;

    if (adBlockImages?.length) {
      //@ts-ignore
      const originalImage = adBlockImages.find((img: any) => img.size === 'original' || !img.size) || adBlockImages[0];
      titleImages = originalImage ? [originalImage] : undefined;
    }

    return (
      <ProjectCardLayoutNew
        key="ad-block-card"
        identifier={team?.teamId}
        title={adBlockTitle}
        titleImages={titleImages}
        linkTo={adBlockLink || undefined}
        withoutGoToProject={!adBlockLink}
        projectType={'t-shape'}
        lmsCardType={'t-shape'}
        itemType={itemType}
        topBadge={<PartnerBadge>{t('text.partner_material')}</PartnerBadge>}
      />
    );
  }, [team, i18n.language, itemType, currentTab]);

  return adBlockCard;
};

